import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const HeroSection = ({
  image,
  title,
  subtitle,
  showCTA = false,
  ctaText = 'Prendre RDV',
  ctaLink = '/rendez-vous',
  secondaryCTA,
  secondaryCTALink,
  overlay = true,
  height = 'h-[60vh]',
  titleSize = 'text-6xl md:text-7xl lg:text-8xl',
  children
}) => {
  return (
    <section className={`relative ${height} min-h-[400px] flex items-center justify-center overflow-hidden`}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
          loading="eager"
        />
        {overlay && (
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
        )}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <h1 className={`${titleSize} font-neuropolitical font-bold text-white mb-4 tracking-tight drop-shadow-lg`}>
          {title}
        </h1>
        {subtitle && (
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto drop-shadow">
            {subtitle}
          </p>
        )}
        {children}
        {showCTA && (
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-6">
            <Link to={ctaLink}>
              <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 text-lg shadow-lg hover:shadow-xl transition-all">
                {ctaText}
              </Button>
            </Link>
            {secondaryCTA && (
              <Link to={secondaryCTALink || '#contact'}>
                <Button size="lg" variant="outline" className="bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 px-8 py-3 text-lg">
                  {secondaryCTA}
                </Button>
              </Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
